export default __webpack_public_path__ + "static/media/kongaLogo.7f962387.webp";